import {
  cleanSignature,
  extractTextFromMarkdown,
  stripUnsupportedMarkdown,
} from './editorHelper';

// Migrate the old automatically inserted signature without dropping the reply below it.
export function stripDraftSignature(
  body = '',
  signature = '',
  channelType = ''
) {
  if (!signature) return body;
  const variants = [
    cleanSignature(signature),
    cleanSignature(stripUnsupportedMarkdown(signature, channelType)),
    extractTextFromMarkdown(signature),
  ].filter(Boolean);
  const value = variants.find(
    candidate =>
      body.trim() === candidate ||
      body.startsWith(`${candidate}\n`) ||
      body.endsWith(`\n\n${candidate}`)
  );
  if (!value) return body;
  if (body.trim() === value) return '';
  if (body.startsWith(`${value}\n`))
    return body.slice(value.length).trimStart();
  return body
    .slice(0, -`\n\n${value}`.length)
    .replace(/\n+--\s*$/, '')
    .trimEnd();
}

export function withInlineSignature(body = '', signature = '', options = {}) {
  if (!body.trim() || !signature) return body;
  const prepared = options.channelType
    ? stripUnsupportedMarkdown(signature, options.channelType)
    : signature;
  const label = cleanSignature(prepared)
    .replace(/\\?\n+/g, ' ')
    .trim();
  if (!label) return body;
  const colon = extractTextFromMarkdown(label).trim().endsWith(':') ? '' : ':';
  const separator = options.layout === 'next_line' ? '\n' : ' ';
  return `${label}${colon}${separator}${body.trimStart()}`;
}
